import { Machine } from '@/services/model/machine'
import { useEffect, useState } from 'react'

export type UseMachineResult = {
  machine: Machine | undefined
  error: boolean
}

export function useMachine(mid?: string | number): UseMachineResult {
  const [machine, setMachine] = useState<Machine | undefined>(undefined)
  const [error, setError] = useState<boolean>(false)

  useEffect(() => {
    if (mid == null) {
      setMachine(undefined)
      setError(false)
      return
    }

    const controller = new AbortController()
    setMachine(undefined)
    setError(false)

    fetch(`/api/communal/machines/byid/${mid}`, { signal: controller.signal })
      .then((res) => {
        if (!res.ok) throw new Error(`Failed to load machine (${res.status})`)
        return res.json()
      })
      .then((data) => setMachine(data))
      .catch((e) => {
        if (controller.signal.aborted) return
        setError(true)
        setMachine(undefined)
      })

    return () => controller.abort()
  }, [mid])

  return { machine, error }
}